import React, { useMemo } from 'react';
import isString from 'lodash/isString';
import { noAnchorTargetsDompurify } from '../utils/customDomPurifyInstances';

const TermsContent = ({ termsContent }) => {
	const sanitizedContent = useMemo(
		() => (isString(termsContent) ? noAnchorTargetsDompurify.sanitize(termsContent) : ''),
		[termsContent]
	);
	return (
		<div
			className="common-terms-content"
			data-qa="termscontent"
			{...{ dataqa: 'termscontent' }}
			/**
			 * `dangerouslySetInnerHTML` is React's replacement for using `innerHtml` in the browser DOM.
			 * It is advised to use cautiously, so we're utilizing `DOMPurify` node package to strengthen
			 * the security. For more information, visit http://jira/browse/WEBAPPS-19690.
			 */
			// eslint-disable-next-line
			dangerouslySetInnerHTML={{
				__html: sanitizedContent,
			}}
		/>
	);
};

export default TermsContent;
